import React, { useEffect, useRef, useState } from "react";
import styles from "./CreateInspirationalGallery.module.css";
import AddImage from "../../../assets/RoomImage.png";
import {
  DropDown,
  InputField,
  SubmitButton,
  TextComponent,
} from "../../../components";
import { Col, List, Row, Switch } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { BsChevronDown, BsChevronUp } from "react-icons/bs";
import { IoMdCheckbox, IoMdSquareOutline } from "react-icons/io";
import { showAlert } from "../../../Store/Actions/GeneralActions";
import { InspirationalGalleryMiddleware } from "../../../Store/Middlewares/InspirationalGalleryMiddleware";
import { EventMiddleware } from "../../../Store/Middlewares/EventMiddleware";
import { BiSolidMinusCircle } from "react-icons/bi";

const CreateInspirationalGallery = () => {
  const { state } = useLocation();
  console.log("stateeeeInsp", state);
  const categoryID = state?.state?.cat_id;
  const screenType = state?.screenType;
  const editData = state?.state?.item;
  // const EventCategory = useSelector(
  //   (state) => state?.GeneralReducer?.GeneralTypes?.inspirationgallery
  // );
  const EventCategory = useSelector(
    (state) => state.EventReducer.EventDetails?.inspiration_gallery_categories
  );

  const [category, setCategory] = useState(
    categoryID ? EventCategory?.find((e) => e?.id == categoryID) : null
  );
  const [vendor, setVendor] = useState("");
  const [checked, setchecked] = useState(false);
  const [open, setOpen] = useState("");
  const [selectedVendors, setselectedVendors] = useState([]);
  console.log("selectedVendors/////////", selectedVendors);

  const [galleryImg, setGalleryImg] = useState([]);
  const [galleryName, setGalleryName] = useState(
    editData?.name ? editData?.name : null
  );

  const imageRef = useRef();
  const dispatch = useDispatch();

  const VendorsList = useSelector(
    (state) => state.EventReducer.EventDetails?.vendors
  );

  // console.log("categorycategory", EventCategory?.find(e=>e?.id == categoryID));
  useEffect(() => {
    dispatch(EventMiddleware.getEventDetails({ id: state?.event_id }));
  }, []);
  const navigate = useNavigate();
  const handleImageClick = () => {
    imageRef.current.click();
  };
  const handleChangeCategory = (value) => {
    setCategory(value);
  };
  const handleChangeVendor = (value) => {
    setVendor(value);
  };
  const onChange = (checked) => {
    setchecked(checked);
    // console.log(`switch to ${checked}`);
  };
  const selectItem = (item) => {
    let newArr = [...selectedVendors];
    newArr.push(item);
    setselectedVendors(newArr);
  };
  const unSelectItem = (item) => {
    let newArr = selectedVendors.filter((e) => e?.id != item?.id);
    setselectedVendors(newArr);
  };
  const onPressCreateGallery = () => {
    if (galleryImg?.length <= 0) {
      dispatch(showAlert({ type: "Error", message: "Please select image" }));
    } else if (!state?.category.category_id) {
      dispatch(showAlert({ type: "Error", message: "Please select category" }));
    } 
    // else if (!galleryName) {
    //   dispatch(
    //     showAlert({ type: "Error", message: "Please enter image name" })
    //   );
    // } 
    else if (checked == false && selectedVendors?.length == 0) {
      dispatch(showAlert({ type: "Error", message: "Please select vendors" }));
    } else {
      let gallery_data = {
        event_id: state?.event_id,
        // name: galleryName,
        image: galleryImg,
        client_category_id: state?.category.category_id,
        allow_to_view: checked ? 1 : 0,
        vendors: selectedVendors,
      };
      dispatch(InspirationalGalleryMiddleware.createGallery(gallery_data))
        .then(() => navigate(-1))
        .catch((err) => console.log(err));
    }
  };
  const onPressUpdateGallery = () => {
    let gallery_data = {
      id: editData?.id,
      event_id: state?.state?.event_id,
      client_category_id: state?.category.category_id
        ? state?.category.category_id
        : undefined,
      name: galleryName ? galleryName : undefined,
    };

    dispatch(InspirationalGalleryMiddleware.updateGallery(gallery_data))
      .then(() => navigate(-1))
      .catch((err) => console.log(err));
  };
  const renderItem = (item, index) => {
    const focus = selectedVendors?.find((x) => x?.id == item?.id);
    return (
      <div
        className={styles.VD_listItem}
        onClick={focus ? () => unSelectItem(item) : () => selectItem(item)}
      >
        {focus ? (
          <div className={styles.checkDiv}>
            <IoMdCheckbox className={styles.checkIcon} />
          </div>
        ) : (
          <div className={styles.checkDiv}>
            <IoMdSquareOutline className={styles.checkIcon} />
          </div>
        )}
        <div className={styles.listItemText}>
          <TextComponent text={item?.name} />
        </div>
      </div>
    );
  };
  const deleteImage = (index) => {
    console.log("iddddddddd", index);
    let imgObjCpy = [...galleryImg];
    imgObjCpy.splice(index, 1);
    setGalleryImg(imgObjCpy);
  };

  const renderImages = (item, index) => {
    console.log("item", item);
    return (
      <div className={styles.listItem}>
        <img src={URL.createObjectURL(item)} />

        {/* <div className={styles.icon}> */}
        <BiSolidMinusCircle
          className={styles.icon}
          onClick={() => deleteImage(index)}
        />
        {/* </div> */}
      </div>
    );
  };

  return (
    <div className={styles.mainCon}>
      <Row className={styles.subMainCon}>
        {/* <Col className={styles.subLeft}> */}
        <Col className={styles.subLeft}>
          {/* <DropDown
            label={"Category"}
            placeholder={"Flowers"}
            stylesClass={styles.dropdown}
            name={"category"}
            onChange={handleChangeCategory}
            object={EventCategory}
          /> */}
          <InputField
            styles={styles.input}
            label="Category Name"
            value={state?.category?.category_name}
            disabled
          />

          {/* <InputField
            styles={styles.input}
            label="Name"
            placeholder={"Rose"}
            value={galleryName}
            onChange={(e) => setGalleryName(e.target.value)}
          /> */}
          {screenType != "Edit" && (
            <>
              <div className={styles.toggleDiv}>
                <TextComponent
                  text={"Allow Everyone To View"}
                  textClass={styles.toggleTxt}
                />
                <Switch
                  defaultChecked={false}
                  onChange={onChange}
                  size={"default"}
                  style={{ backgroundColor: checked && "var(--primary-color)" }}
                />
              </div>

              {!checked && (
                <div className={styles.vendorDropdown}>
                  {/* <label className={`${styles.label} ${labelClass}`}>{label}</label> */}
                  <div
                    className={styles.VD_textDiv}
                    onClick={() => setOpen(!open)}
                  >
                    <div className={styles.VD_text}>
                      {selectedVendors?.length == 0 ? (
                        <TextComponent text={"Select Vendor"} />
                      ) : (
                        selectedVendors
                          ?.filter((item, idx) => idx < 3)
                          ?.map((item, index) => {
                            return (
                              <TextComponent
                                text={`${item?.name} -`}
                              ></TextComponent>
                            );
                          })
                      )}
                      {selectedVendors?.length > 3 && (
                        <TextComponent text={"....."} />
                      )}
                    </div>
                    {open ? (
                      <BsChevronUp size={20} />
                    ) : (
                      <BsChevronDown size={20} />
                    )}
                  </div>
                  {open && VendorsList?.length > 0 ? (
                    <div className={styles.VD_list}>
                      <List dataSource={VendorsList} renderItem={renderItem} />
                    </div>
                  ) : null}
                </div>
              )}
            </>
          )}
        </Col>
        <Col className={styles.subRight}>
          <img
            className={styles.uploadImg}
            src={AddImage}
            onClick={handleImageClick}
            //  src={galleryImg ?  URL.createObjectURL(galleryImg) : AddImage}
          />
          <input
            type="file"
            accept="image/*"
            multiple
            onChange={(e) => {
              e.preventDefault();
              setGalleryImg([...galleryImg, ...e.target.files]);
            }}
            ref={imageRef}
            style={{ display: "none" }}
          />
          <List
            className={styles.list}
            grid={{ gutter: 16 }}
            itemLayout="horizontal"
            dataSource={galleryImg}
            renderItem={renderImages}
          />
        </Col>
      </Row>
      <div className={styles.btnDiv}>
        <SubmitButton
          title={screenType == "Edit" ? "Save" : "Create"}
          btnClass={styles.btn}
          onClick={
            screenType == "Edit" ? onPressUpdateGallery : onPressCreateGallery
          }
        />
      </div>
    </div>
  );
};

export default CreateInspirationalGallery;
